<template>
	<div class="sinfo_list">
		<div class="content_list" v-for="(item,index) in infoList" :key="index" @click="showDetail(item)">
			<p class="content_list_firstp">·</p>
			<p class="content_list_lastp">{{item.news_title}}</p>
			<span>{{item.publish_time}}</span>
		</div>
		<!--<div v-show="totalNum>10" style="text-align: center;margin: 20px 0;">
			<el-pagination v-if="page_size>7" @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="page_size"
				layout="total, sizes, prev, pager, next, jumper" :total="totalNum">
			</el-pagination>
		</div>-->
		
	</div>
</template>

<script>
	import {
		apiRequest
	} from '../../../api/api.js'

	export default {
		data() {
			return {
				infoList: [],
				currentPage:1,
				totalNum:0,
				columnCode:''
			}
		},
		props: {
			orgin: {
				type: String,
				default: 'announce'
			},
			column_code: {
				type: String,
				default: ''
			},
			page_size: {
				type: Number,
				default: 10
			}
		},
		watch: {
			column_code(newValue) {
				this.columnCode = newValue
				this.getInformation(newValue,1 ,this.page_size, '1')
			}
		},
		created() {

		},
		methods: {
			handleSizeChange(val){
				this.pageSize = val
				this.getInformation(this.columnCode,this.currentPage,val,'1')
			},
			handleCurrentChange(val){
				this.currentPage = val
				this.getInformation(this.columnCode,val,this.page_size,'1')
			},
			showDetail(item) {
				/*if (this.orgin) {

				}*/

				this.$router.push(`/detail/${item.id}`)
			},
			// 获取栏目资讯列表
			async getInformation(column_code,pageNo, pageSize, model) {
				await apiRequest({
					method: 'post',
					url: '/adminapi/web/get-web-news-list',
					data: {
						column_code,
						pageNo,
						pageSize,
						model
					},
					success: (res) => {

						console.log('获取文章列表')

						this.infoList = res.data
						this.totalNum = parseInt(res.total)
					}
				})
			},
		}
	}
</script>

<style scoped>
	.sinfo_list {
		/* width: 506px; */
	}

	.sinfo_list_head {
		display: flex;
		justify-content: space-between;
		margin-bottom: 10px;
	}

	.sinfo_list_head p {
		font-family: PingFangSC-Semibold;
		font-size: 20px;
		color: #131415;
		letter-spacing: 0;
		font-weight: 600;
	}

	.big_title_box {
		min-width: 100px;
		display: flex;
		height: 40px;
		line-height: 40px;
		padding-right: 10px;
	}

	.big_title_p {
		min-width: 100px;
		font-family: PingFangSC-Semibold;
		font-size: 24px;
		color: #131415;
		letter-spacing: 0;
		text-align: center;
		font-weight: 600;
		margin-left: 15px;
	}

	/* 咨询列表-可复用 */
	.content_list {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 0 10px 0 20px;
		border-bottom: 2px dotted #f5f5f5;
	}

	.content_list p:hover {
		color: #015AAA;
		text-decoration: underline;
		cursor: pointer;
	}

	.content_list_firstp {
		font-size: 35px;
	}

	.content_list_lastp {
		font-family: PingFangSC-Regular;
		font-size: 15px;
		color: #000000;
		letter-spacing: 0;
		text-align: left;
		line-height: 24px;
		font-weight: 400;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		width: calc(100% - 100px);
	}

	.content_list span {
		font-family: PingFangSC-Regular;
		font-size: 14px;
		color: #000000;
		letter-spacing: 0;
		text-align: left;
		line-height: 24px;
		font-weight: 400;
	}

	.sinfo_list_head_span {
		font-family: PingFangSC-Regular;
		font-size: 14px;
		color: #D40D16;
		letter-spacing: 0;
		text-align: center;
		line-height: 40px;
		font-weight: 400;
	}

	.sinfo_list_head_span:hover {
		cursor: pointer;
		text-decoration: underline;
	}
</style>
